import axios from "axios";
import { getAuth, onAuthStateChanged } from "firebase/auth";

let authReadyPromise;

const waitForAuthReady = (auth) => {
  if (auth.currentUser) return Promise.resolve(auth.currentUser);
  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve, reject) => {
      let unsubscribe = () => {};
      unsubscribe = onAuthStateChanged(
        auth,
        (user) => {
          unsubscribe();
          resolve(user);
        },
        reject
      );
    });
  }
  return authReadyPromise;
};

const axiosApi = axios.create({
  baseURL:
    process.env.VUE_APP_API_BASE_URL ||
    "https://us-central1-citizen-drohobych.cloudfunctions.net/api",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosApi.interceptors.request.use(async (config) => {
  const auth = getAuth();
  await waitForAuthReady(auth);
  const currentUser = auth.currentUser;
  if (currentUser) {
    config.headers.Authorization = `Bearer ${await currentUser.getIdToken()}`;
  }
  return config;
});

axiosApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const currentUser = getAuth().currentUser;
    const config = error.config;
    if (error.response && error.response.status === 401 && currentUser &&
      config && !config._authRetry) {
      config._authRetry = true;
      config.headers.Authorization = `Bearer ${await currentUser.getIdToken(true)}`;
      return axiosApi(config);
    }
    throw error;
  }
);

const fileApi = axios.create({
  baseURL:
    process.env.VUE_APP_FILE_API_BASE_URL ||
    "https://project.realno.top/api/file/save/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default { axiosApi, fileApi };
